<script lang="ts" setup>
import type { GameItem } from '@kira-dancer/nuxt-common'
import { useTopJackpot } from '~/composables/top-jackpot/use-top-jackpot'
import { SlidersPerView } from '~/enums'

const { jackpotGameSorting, handlePlayingGame, gameJackpotTopOne } =
  useTopJackpot()
const { isMobile } = useDevice()

const swiperOptions = {
  loop: false,
  grabCursor: true,
  navigation: !isMobile
    ? {
        prevEl: '.jackpot-swiper-prev',
        nextEl: '.jackpot-swiper-next',
      }
    : undefined,
  slidesPerView: SlidersPerView.Auto,
  spaceBetween: 0,
}
</script>

<template>
  <div v-if="jackpotGameSorting?.length" class="top-jackpot-section">
    <div class="supper-jackpot">
      <div
        class="supper-jackpot__overlay"
        @click="handlePlayingGame(gameJackpotTopOne)"
      />
      <div class="bg-supper-jackpot">
        <img
          src="/images/home/top-jackpot/bg-supper-jackpot.webp"
          alt="bg supper jackpot"
          width="492"
          height="242"
          loading="lazy"
        />
      </div>
      <div class="supper-jackpot__item">
        <CommonGameItem
          :is-hide-jackpot-number="true"
          :is-hide-effect-hover="true"
          :item="gameJackpotTopOne"
        />
      </div>
      <div class="wrap-supper-jackpot-number">
        <div
          v-if="gameJackpotTopOne?.jackpotNumber"
          class="supper-jackpot__number"
        >
          <BaseAnimatedNumber
            :number="gameJackpotTopOne?.jackpotNumber"
            :start="gameJackpotTopOne?.jackpotNumber"
          />
        </div>
      </div>
      <BaseButton
        label="Cược ngay"
        variant="primary"
        size="small"
        button-id="bet-supper-jackpot"
        button-name="bet-supper-jackpot"
        @click="handlePlayingGame(gameJackpotTopOne)"
      />
    </div>

    <div class="jackpots">
      <div class="jackpots__content">
        <BaseSwiper
          :items="jackpotGameSorting.slice(1)"
          :options="swiperOptions"
        >
          <template #item="{ item }: { item: GameItem }">
            <CommonGameItem :item="item" />
          </template>
        </BaseSwiper>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/styles/components/desktop/home/top-jackpot-section.scss';
</style>
